import "./index.scss";
import AppRoute from "./Router/AppRouter";
import { CarProvider } from "./Context/CarContext";
import { AuthProvider } from "./Context/AuthContext";
import { ServiceProvider } from "./Context/ServiceContext";
import { NotificationProvider } from "./Context/NotificationContext";

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CarProvider>
          <ServiceProvider>
            <AppRoute />
          </ServiceProvider>
        </CarProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}
export default App;